import React, { useState, useEffect } from "react";
import { Typography, Table, TableFooter, AnchorMenu } from "components";
import { useSelector, useDispatch } from "react-redux";
import {
  getTerminalRequests,
  getTerminals,
} from "redux/actions/terminalAction";
import { ROUTES } from "routes/routePaths";
import AgentRequestViewModal from "./AgentRequestViewModal";
import { useNavigate } from "react-router-dom";
import MapTerminalModal from "./MapTerminalModal";

const AgentsRequests = ({ size }) => {
  const [isModalOpen, setModalIsOpen] = useState(false);
  const [status, setStatus] = useState(2);
  const [terminalDetails, setTerminalDetails] = useState({});
  const dispatch = useDispatch();
  const handleOpen = () => setModalIsOpen(true);
  const handleClose = () => {
    setModalIsOpen(false);
    setStatus(2);
  };

  const populateData = (value) => {
    handleOpen();
    setTerminalDetails(value);
  };

  const navigate = useNavigate();
  /**
   *
   */
  const { terminalRequests, requestsTotal, terminals, isLoading } = useSelector(
    (state) => ({
      terminalRequests: state.terminalReducer.terminalRequests,
      requestsTotal: state.terminalReducer.requestsTotal,
      terminals: state.terminalReducer.terminals,
      isLoading: state.asynReducer.isLoading,
    })
  );

  const initialFilterState = {
    number: 1,
    size: size || 10,
  };

  const [filterState, setFilterState] = useState(initialFilterState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterState({ ...filterState, [name]: value });
  };

  /**
   *
   */
  useEffect(() => {
    // const requestParams = {}
    dispatch(getTerminalRequests(filterState));
  }, [dispatch, filterState]);

  useEffect(() => {
    const requestParams = {
      // agentId: user?.agent_id
    };
    dispatch(getTerminals(requestParams));
  }, [dispatch]);

  /**
   *
   */
  const columns = [
    {
      Header: "S/N",
      Cell: (row) => Number(row.row.id) + 1,
    },
    {
      Header: "Corporate Account?",
      accessor: "isCorporate",
      Cell: ({ value }) => (value ? "Yes" : "No"),
    },
    {
      Header: "Agent Name",
      accessor: "agentName",
    },
    {
      Header: "Agent Code",
      accessor: "agentCode",
    },
    {
      Header: "Region",
      accessor: "region",
    },
    {
      Header: "State",
      accessor: "state",
    },
    {
      Header: "Terminal Location",
      accessor: "pickupLocation",
    },
    {
      Header: "Request Type",
      accessor: "requestType",
      Cell: ({ row }) => {
        return row.original.requestType.toString() === "1" ||
          row.original.requestType.toString() === "NEW"
          ? "NEW"
          : "SWAP";
      },
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Action",
      Cell: ({ row }) => {
        return (
          (row.original.requestType.toString() === "2" ||
            row.original.status === "NEW_REQUEST") && (
            <AnchorMenu anchorRender={() => anchorRender(row.original)} />
          )
        );
      },
    },
  ];

  const anchorRender = (value) => {
    return (
      <ul className="py-1" style={{ paddingLeft: "1rem" }}>
        {value.requestType.toString() === "2" && (
          <li
            onClick={() => {
              setStatus(1);
              populateData(value);
            }}
            className="cursor-pointer"
          >
            <Typography state="primary" variant="body3">
              View Request
            </Typography>
          </li>
        )}
        <li className="mt-1">
          {value.status === "NEW_REQUEST" && (
            <Typography
              state="primary"
              variant="body3"
              className={"cursor-pointer"}
              onClick={() => populateData(value)}
            >
              Map Terminal
            </Typography>
          )}
        </li>
      </ul>
    );
  };

  return (
    <React.Fragment>
      <div className="terminal-requests-container">
        <div className="d-flex justify-content-between">
          <Typography variant="subtitle3" state="primary">
            Pending Terminal Requests
          </Typography>
          {size ? (
            <Typography
              variant="caption0"
              state="secondary"
              className={"cursor-pointer"}
              onClick={() => navigate(ROUTES.terminalRequests)}
            >
              View All
            </Typography>
          ) : (
            <Typography variant="body2" state="grey">
              Requested by Agents
            </Typography>
          )}
        </div>
        {/* <Sorter /> */}
        <div className="mt-2">
          <Table columns={columns} centerData data={terminalRequests} />
          {terminalRequests?.length && !size ? (
            <TableFooter
              pageSize={filterState.size}
              handleChange={handleChange}
              availableDataLength={terminalRequests.length}
              totalDataLength={requestsTotal}
              handlePageClick={(pageNo) =>
                setFilterState({ ...filterState, number: pageNo })
              }
            />
          ) : (
            ""
          )}
        </div>
      </div>
      {/**
       * Display Modal here
       * @props {arrray} - terminalDetails  (contain row record to be display)
       */}
      {isModalOpen && (
        <>
          {status === 1 ? (
            <AgentRequestViewModal
              showModal={isModalOpen}
              onClose={handleClose}
              data={terminalDetails}
            />
          ) : (
            <MapTerminalModal
              showModal={isModalOpen}
              onClose={handleClose}
              data={terminals}
              terminalDetails={terminalDetails}
              isLoading={isLoading}
            />
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default AgentsRequests;
